/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, OnInit, signal} from '@angular/core';
import {UIRouter} from '@uirouter/core';
import * as _ from 'lodash';

import {ApiConfig} from '../../config/api-config';
import {AdnShotterService} from '../../common/adn-shotter.service';
import {OBJECT_TYPE} from '../../common/constants/object-type';
import {buildLastViewedEntries} from './simple-last-viewed.util';
import template from './shotter-page.component.html';
import {SIMPLE_PAGE_IMPORTS} from './simple-page-imports';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';
import {LocalUserProfile} from '../../../components/session/local-user-profile';
import {NavigationHistoryService} from '../../../components/util/navigation-history.service';

@Component({
  standalone: true,
  imports: SIMPLE_PAGE_IMPORTS,
  selector: 'adn-shotter-page',
  template
})
export class ShotterPageComponent implements OnInit {
  lastViewed: any[] = [];
  lastViewedObject: any;
  selectFrom = 'CUSTOM';

  url = 'https://www.vg.no/nyheter/i/8q7POE/krigen-i-midtoesten-trenger-ikke-aa-vente-paa-trump';
  width = 300;
  height = 250;
  device = 'DESKTOP';
  theScript = '';
  private readonly screenshotsState = signal<any[] | undefined>(undefined);
  private readonly screenshottingState = signal(false);
  private readonly deletingState = signal(false);
  private readonly loadedState = signal(true);
  private readonly respState = signal<any>(undefined);
  get screenshots(): any[] { return this.screenshotsState(); }
  set screenshots(value: any[]) { this.screenshotsState.set(value); }
  get screenshotting(): boolean { return this.screenshottingState(); }
  set screenshotting(value: boolean) { this.screenshottingState.set(value); }
  get deleting(): boolean { return this.deletingState(); }
  set deleting(value: boolean) { this.deletingState.set(value); }
  showScreenshots: boolean;
  get loaded(): boolean { return this.loadedState(); }
  set loaded(value: boolean) { this.loadedState.set(value); }
  objectId: string;
  objectType: any;
  objectTypes = OBJECT_TYPE;
  hashResults = true;
  get resp(): any { return this.respState(); }
  set resp(value: any) { this.respState.set(value); }
  bypassSave: boolean;
  headless: boolean;

  constructor(
    @Inject(LocalUserProfile) localUserProfile: any,
    @Inject(LocalNetworkProfile) private readonly LocalNetworkProfile: any,
    private readonly adnShotter: AdnShotterService,
    private readonly uiRouter: UIRouter,
    navigationHistory: NavigationHistoryService,
    private readonly apiConfig: ApiConfig
  ) {
    this.lastViewed = buildLastViewedEntries(localUserProfile, this.LocalNetworkProfile);
    this.lastViewedObject = _.get(this.lastViewed, [0]);
    this.objectId = navigationHistory.previousParams.id;
    this.objectType = _.find(_.values(OBJECT_TYPE), (ot) => ot.stateName === navigationHistory.previousState?.name);
  }

  get displayLoaded(): boolean {
    return this.loaded;
  }

  ngOnInit(): void {
    const creativeId = this.uiRouter.globals.params.creativeId;
    if (creativeId) {
      this.objectId = creativeId;
      this.doCheck();
    }
  }

  updateScript(): void {
    const theChildren = [{
      cId: this.objectId,
      w: this.width,
      h: this.height
    }];
    const env = this.apiConfig.getId().replace('_adn', '');
    this.theScript = 'var scriptEl = document.createElement("script");scriptEl.src=("https://cdn.adnuntius.com/shotter.js?env=' + env + '&cjson=' + encodeURIComponent(JSON.stringify(theChildren)) + '&networkId=' + this.LocalNetworkProfile.getNetworkTag() + '");document.body.appendChild(scriptEl);';
  }

  refresh(): void {
    this.screenshotting = true;
    this.adnShotter.fetchAll().then((data: any[]) => {
      this.screenshots = data;
      _.forEach(this.screenshots, (s) => {
        s.articleUrlHttps = (s.articleUrl || '').indexOf('http') === 0 ? s.articleUrl : 'https://' + s.articleUrl;
      });
    }).finally(() => {
      this.screenshotting = false;
    });
  }

  deleteScreenshot(screenshot: any, index: number): void {
    this.deleting = true;
    this.adnShotter.deleteScreenshot(screenshot).then(() => {
      _.pullAt(this.screenshots, index);
    }).finally(() => {
      this.deleting = false;
    });
  }

  doCheck(): void {
    this.loaded = false;
    this.adnShotter.takeShot(this.objectId, null, this.url, this.device, this.bypassSave, this.headless).then((data: any) => {
      this.loaded = true;
      this.resp = data;
    });
  }
}
